/**
 * locale catalogs for waiter
 */
export var WAITER_LOCALE_CATALOGS = ["waiter", "shared"];